// Words that must stay fully upper-cased when a state token is humanized for

// display (e.g. `ai_unsubscribed` -> `AI Unsubscribed`, not `Ai Unsubscribed`).
const STATE_ACRONYMS = new Set(['ai', 'sms', 'did', 'url', 'id', 'api']);

/**
 * Render a contact-state token as a human label: split on underscores and
 * Title-Case each word, keeping known acronyms upper-cased. Case-insensitive on
 * input, so it presents legacy uppercase tokens and the new lowercase
 * `snake_case` tokens identically (`DIALER_READY_TO_START` and
 * `dialer_ready_to_start` both render `Dialer Ready To Start`).
 */
export const humanizeState = (value?: string | null): string => {
  if (!value) return '';

  return value
    .replace(/_/g, ' ')
    .trim()
    .split(/\s+/)
    .map(word => {
      const lower = word.toLowerCase();
      if (STATE_ACRONYMS.has(lower)) return lower.toUpperCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(' ');
};

export const asStateOption = <T extends string>(value: T): OptionType<T> => ({
  value,
  label: humanizeState(value),
});

export const asStateOptions = <T extends string>(
  value: T[]
): OptionType<T>[] => {
  return value.map(v => asStateOption(v));
};
